import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2 w-full" }
const _hoisted_2 = { class: "flex flex-row justify-center items-center text-center relative gap-2" }
const _hoisted_3 = { class: "text-2xl underline font-bold text-red-lp-100 w-max" }
const _hoisted_4 = { class: "rounded-lg border border-gray-lp-2100 bg-gray-lp-100 p-2" }
const _hoisted_5 = { class: "flex flex-col border border-gray-lp-1400 w-full text-gray-lp-300 text-xs" }
const _hoisted_6 = { class: "flex flex-row py-2 px-2 border-b border-gray-lp-1400" }
const _hoisted_7 = { class: "w-1/3 flex flex-col gap-1 justify-center" }
const _hoisted_8 = { class: "font-semibold text-sm" }
const _hoisted_9 = { class: "w-1/3 border-l border-r border-gray-lp-1400 flex flex-col gap-1 justify-center" }
const _hoisted_10 = { class: "px-2 py-0.5 bg-gray-lp-200 rounded text-sm font-medium self-center" }
const _hoisted_11 = { class: "w-1/3 flex flex-col gap-1 justify-center" }
const _hoisted_12 = { class: "font-semibold text-sm" }
const _hoisted_13 = { class: "w-full flex flex-row py-2 px-2" }
const _hoisted_14 = { class: "w-2/3 flex flex-col gap-1 justify-destination" }
const _hoisted_15 = { class: "font-semibold text-sm" }
const _hoisted_16 = { class: "w-64 border-l border-gray-lp-1400 flex flex-col gap-1 justify-center" }
const _hoisted_17 = { class: "font-semibold text-sm" }
const _hoisted_18 = { class: "py-1 px-2 rounded-lg border border-gray-lp-1400 bg-gray-lp-1000" }
const _hoisted_19 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_20 = { class: "flex flex-row justify-between items-center" }
const _hoisted_21 = { class: "text-xs text-gray-lp-300" }
const _hoisted_22 = { class: "text-sm text-gray-lp-300 font-semibold" }
const _hoisted_23 = { class: "flex flex-row justify-between items-center" }
const _hoisted_24 = { class: "text-xs text-gray-lp-300 font-semibold" }
const _hoisted_25 = { class: "flex flex-col items-end gap-1 text-right" }
const _hoisted_26 = {
  class: "text-sm text-gray-lp-300 font-bold",
  "data-testid": "booking-success-modal-cod-amount"
}
const _hoisted_27 = {
  key: 0,
  class: "flex flex-row items-center gap-1"
}
const _hoisted_28 = {
  key: 0,
  class: "summary-discount-chip summary-discount-chip--label",
  "data-testid": "booking-success-modal-discount-badge-0"
}
const _hoisted_29 = { class: "summary-discount-chip__text" }
const _hoisted_30 = {
  key: 1,
  class: "text-12px font-semibold text-gray-lp-600"
}
const _hoisted_31 = {
  key: 2,
  class: "summary-discount-chip summary-discount-chip--amount",
  "data-testid": "booking-success-modal-voucher-discount-badge"
}
const _hoisted_32 = { class: "summary-discount-chip__text" }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "flex flex-row justify-between items-center" }
const _hoisted_35 = { class: "text-xs text-gray-lp-300 font-semibold" }
const _hoisted_36 = { class: "flex flex-row text-sm text-gray-lp-300 font-semibold gap-1 items-center" }
const _hoisted_37 = { class: "flex flex-row gap-1 items-center" }
const _hoisted_38 = { class: "text-gray-lp-300 font-semibold items-center text-center" }
const _hoisted_39 = { class: "flex items-center justify-between gap-4 w-full" }
const _hoisted_40 = { class: "flex items-center justify-end gap-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Modal = _resolveComponent("Modal")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock(_component_Modal, _mergeProps(_ctx.messageEntities, { ref: "modal-ref" }), {
    custom: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _withDirectives(_createVNode("img", {
            class: "invisible",
            src: 
              require(`@/app/ui/assets/svg/${
                _ctx.detailData.isDfod ? 'dfod' : 'cod'
              }-logo-2.svg`)
            
          }, null, 8, ["src"]), [
            [_vShow, _ctx.detailData.isCod || _ctx.detailData.isDfod]
          ]),
          _createVNode("h1", _hoisted_3, _toDisplayString(_ctx.detailStt.sttNo), 1),
          _withDirectives(_createVNode("div", _hoisted_4, [
            _createVNode("img", {
              src: 
                require(`@/app/ui/assets/svg/${
                  _ctx.detailData.isDfod ? 'dfod' : 'cod'
                }-logo-2.svg`)
              
            }, null, 8, ["src"])
          ], 512), [
            [_vShow, _ctx.detailData.isCod || _ctx.detailData.isDfod]
          ])
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode("div", null, _toDisplayString(_ctx.$t("bookingV3.modalSuccess.recipient")), 1),
              _createVNode("div", _hoisted_8, _toDisplayString(_ctx.recipientName), 1)
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode("div", null, _toDisplayString(_ctx.$t("bookingV3.modalSuccess.serviceType")), 1),
              _createVNode("div", _hoisted_10, _toDisplayString(_ctx.detailStt.productType), 1)
            ]),
            _createVNode("div", _hoisted_11, [
              _createVNode("div", null, _toDisplayString(_ctx.$t("bookingV3.modalSuccess.chargableWeight")), 1),
              _createVNode("div", _hoisted_12, _toDisplayString(_ctx.detailStt.chargeableWeight) + " kg ", 1)
            ])
          ]),
          _createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, [
              _createVNode("div", null, _toDisplayString(_ctx.$t("bookingV3.modalSuccess.destination")), 1),
              _createVNode("div", _hoisted_15, _toDisplayString(_ctx.detailStt.sttDestinationDistrictName), 1)
            ]),
            _createVNode("div", _hoisted_16, [
              _createVNode("div", null, _toDisplayString(_ctx.$t("bookingV3.modalSuccess.estimation")), 1),
              _createVNode("div", _hoisted_17, _toDisplayString(_ctx.estimationDate), 1)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_18, [
          (_ctx.detailData.isCod || _ctx.detailData.isDfod)
            ? (_openBlock(), _createBlock("div", _hoisted_19, [
                _createVNode("div", _hoisted_20, [
                  _createVNode("div", _hoisted_21, _toDisplayString(_ctx.$t("bookingV3.modalSuccess.codFee")), 1),
                  _createVNode("div", _hoisted_22, _toDisplayString(_ctx.isBookingClient
                    ? _ctx.formatHidePrice
                    : _ctx.formatPriceCurrency(_ctx.detailData.codFee)), 1)
                ]),
                _createVNode("div", _hoisted_23, [
                  _createVNode("div", _hoisted_24, _toDisplayString(_ctx.$t("bookingV3.modalSuccess.payable")), 1),
                  _createVNode("div", _hoisted_25, [
                    _createVNode("div", _hoisted_26, _toDisplayString(_ctx.formatPriceCurrency(_ctx.detailData.codAmount)), 1),
                    (_ctx.hasPromoDiscount || _ctx.hasVoucherDiscount)
                      ? (_openBlock(), _createBlock("div", _hoisted_27, [
                          (_ctx.combinedPromoDiscountLabel)
                            ? (_openBlock(), _createBlock("div", _hoisted_28, [
                                _createVNode("div", _hoisted_29, _toDisplayString(_ctx.combinedPromoDiscountLabel), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.combinedPromoDiscountLabel && _ctx.hasVoucherDiscount)
                            ? (_openBlock(), _createBlock("div", _hoisted_30, " + "))
                            : _createCommentVNode("", true),
                          (_ctx.hasVoucherDiscount)
                            ? (_openBlock(), _createBlock("div", _hoisted_31, [
                                _createVNode("div", _hoisted_32, " -" + _toDisplayString(_ctx.formatPriceRP(_ctx.detailData.voucherDiscountAmount)), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_33, [
                _createVNode("div", _hoisted_34, [
                  _createVNode("div", _hoisted_35, _toDisplayString(_ctx.$t("bookingV3.modalSuccess.tariff")), 1),
                  _createVNode("div", _hoisted_36, [
                    _withDirectives(_createVNode("div", _hoisted_37, null, 512), [
                      [_directive_sanitize_html, _ctx.generateDiscountElement()]
                    ]),
                    _createVNode("div", _hoisted_38, _toDisplayString(_ctx.isBookingClient
                      ? _ctx.formatHidePrice
                      : _ctx.formatPriceRP(_ctx.detailStt.totalAfterDiscount)), 1)
                  ])
                ])
              ]))
        ])
      ])
    ]),
    "custom-button": _withCtx(() => [
      _createVNode("div", _hoisted_39, [
        _createVNode(_component_LpButton, {
          title: _ctx.$t('bookingV3.modalSuccess.close'),
          textColor: "red-lp-100",
          color: "red-lp-100",
          outline: "",
          "data-testid": "booking-v3-modal-success-button-close",
          onClick: _ctx.onClose
        }, null, 8, ["title", "onClick"]),
        _createVNode("div", _hoisted_40, [
          (_ctx.showCreateInvoice)
            ? (_openBlock(), _createBlock(_component_LpButton, {
                key: 0,
                title: _ctx.$t('bookingV3.modalSuccess.createInvoice'),
                textColor: "red-lp-100",
                color: "red-lp-100",
                outline: "",
                onClick: _ctx.onPreviewInvoice
              }, null, 8, ["title", "onClick"]))
            : _createCommentVNode("", true),
          _createVNode(_component_LpButton, {
            title: _ctx.$t('bookingV3.modalSuccess.print'),
            textColor: "white",
            color: "red-lp-100",
            onClick: _ctx.onSubmit,
            iconLeft: _ctx.textSuccess == 'Muat ulang' ? 'ics_o_sync_white' : ''
          }, null, 8, ["title", "onClick", "iconLeft"])
        ])
      ])
    ]),
    _: 1
  }, 16))
}